import Page from 'components/Page';
import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Table
} from 'reactstrap';

import { FaPencilAlt, FaTrashAlt} from 'react-icons/fa';



const FormPage = () => {
  return (
    <Page title="Formulario 1" breadcrumbs={[ { name: 'Formulario 1', active: true } ]}>


        <Card>
            <CardHeader>Detalle</CardHeader>
            <CardBody>
            <Form>
                <Row className="no-margin-bottom">
                    <Col  xl={2} lg={2} md={2}>
                        <FormGroup check>
                            <Label check>
                                <br/>
                                <Input type="checkbox" /> Cliente VIP
                            </Label>
                        </FormGroup>                  
                    </Col>

                    <Col  xl={2} lg={2} md={2}>
                        <FormGroup check>
                            <Label check>
                                <br/>
                                <Input type="radio" name="radio2" /> X Producto
                            </Label>
                        </FormGroup>  
                        <FormGroup check>
                            <Label check>
                                <Input type="radio" name="radio2" /> X Cliente
                            </Label>
                        </FormGroup>  
                    </Col>

                    <Col  xl={2} lg={2} md={2}>
                        <FormGroup>
                            <Label for="ruta">Ruta</Label>
                            <Input
                                type="text"
                                name="ruta"
                                placeholder=""
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row className="no-margin-bottom">
                    <Col  xl={2} lg={2} md={2}>
                        <FormGroup>
                            <Label for="folio">Folio</Label>
                            <Input
                                type="text"
                                name="folio"
                                placeholder=""
                            />
                        </FormGroup>
                    </Col>
                    <Col  xl={2} lg={2} md={2}>
                        <FormGroup>
                            <Label for="fecha">Fecha</Label>
                            <Input
                                type="date"
                                name="fecha"
                                placeholder=""
                            />
                        </FormGroup>
                    </Col>
                    <Col  xl={2} lg={2} md={2}>
                        <FormGroup>
                            <Label for="condicion">Condición</Label>
                            <select className="mb-2 select-cuerpo" >
                                <option>Cheque</option>
                                <option>Opción 1</option>
                                <option>Opción 2</option>
                                <option>Opción 3</option>
                            </select>
                        </FormGroup>
                    </Col>
                    <Col  xl={3} lg={3} md={3}>
                        <FormGroup>
                            <Label for="cliente">Cliente</Label>
                            <Input
                                type="text"
                                name="cliente"
                                placeholder=""
                            />
                        </FormGroup>
                    </Col>
                    <Col  xl={3} lg={3} md={3}>
                        <FormGroup>
                            <Label for="observaciones">Observaciones</Label>
                            <Input
                                type="text"
                                name="observaciones"
                                placeholder=""
                            />
                        </FormGroup>
                    </Col>
                </Row>
                
            </Form>
            </CardBody>
        </Card>

        <br/>

        <Card>
            <CardHeader>Productos</CardHeader>
            <CardBody>
                <Form>
                    <Row>
                        <Col  xl={3} lg={3} md={3}>
                            <FormGroup>
                                <Label for="item">Item</Label>
                                <Input
                                    type="text"
                                    name="item"
                                    placeholder=""
                                />
                            </FormGroup>
                        </Col>
                        <Col  xl={2} lg={2} md={2}>
                            <FormGroup>
                                <Label for="precio">Precio (valor bruto)</Label>
                                <Input
                                    type="text"
                                    name="precio"
                                    placeholder=""
                                />
                            </FormGroup>
                        </Col>
                        <Col  xl={1} lg={1} md={1}>
                            <FormGroup>
                                <Label for="cantidad">Cantidad</Label>
                                <Input
                                    type="text"
                                    name="cantidad"
                                    placeholder=""
                                />
                            </FormGroup>
                        </Col>
                        <Col  xl={1} lg={1} md={1}>
                            <FormGroup>
                                <Label for="piezas">Piezas</Label>
                                <Input
                                    type="text"
                                    name="piezas"
                                    placeholder=""
                                />
                            </FormGroup>
                        </Col>
                        <Col  xl={2} lg={2} md={2}>
                            <FormGroup>
                                <Label for="comision">Comisión vendedor</Label>
                                <Input
                                    type="text"
                                    name="comision"
                                    placeholder=""
                                />
                            </FormGroup>
                        </Col>
                        <Col  xl={2} lg={2} md={2}>
                            <Button className="btn-cuerpo"  color="primary" size="sm">Agregar item</Button>
                        </Col>

                        <Col className="no-margin-bottom">
                            <Table bordered striped className="tabla-general">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Descripción</th>
                                        <th>Valor</th>
                                        <th>Cantidad</th>
                                        <th>Unidades</th>
                                        <th>Sub total</th>
                                        <th>Peso</th>
                                        <th>% Comisión</th>
                                        <th className="text-center">Opciones</th>
                                    </tr>

                                </thead>
                                <tbody>
                                    <tr>
                                        <td>123456</td>
                                        <td>Descripción ejemplo</td>
                                        <td>$9.999</td>
                                        <td>9</td>
                                        <td>9</td>
                                        <td>$9.999</td>
                                        <td>18 kg.</td>
                                        <td>10</td>
                                        <td className="text-center td-botones">
                                            <Button color="secondary" className="btn-tabla"> <FaPencilAlt/></Button>
                                            <Button color="danger" className="btn-tabla"><FaTrashAlt/></Button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>123456</td>
                                        <td>Descripción ejemplo</td>
                                        <td>$9.999</td>
                                        <td>9</td>
                                        <td>9</td>
                                        <td>$9.999</td>
                                        <td>18 kg.</td>
                                        <td>10</td>
                                        <td className="text-center td-botones">
                                            <Button color="secondary" className="btn-tabla"> <FaPencilAlt/></Button>
                                            <Button color="danger" className="btn-tabla"><FaTrashAlt/></Button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>123456</td>
                                        <td>Descripción ejemplo</td>
                                        <td>$9.999</td>
                                        <td>9</td>
                                        <td>9</td>
                                        <td>$9.999</td>
                                        <td>18 kg.</td>
                                        <td>10</td>
                                        <td className="text-center td-botones">
                                            <Button color="secondary" className="btn-tabla"> <FaPencilAlt/></Button>
                                            <Button color="danger" className="btn-tabla"><FaTrashAlt/></Button>
                                        </td>
                                    </tr>
                                    
                                </tbody>
                            </Table>                     
                        
                        </Col>

                    </Row>
                </Form>
            </CardBody>
        </Card>

        <br/>

        <Card>
            <CardBody>
                <Form>
                    <Row className="no-margin-bottom">
                        <Col  xl={2} lg={2} md={2}>
                            <FormGroup>
                                <Label for="neto">Neto</Label>
                                <Input
                                    type="text"
                                    name="neto"
                                    placeholder=""
                                />
                            </FormGroup>
                        </Col>
                        <Col  xl={2} lg={2} md={2}>
                            <FormGroup>
                                <Label for="ila">ILA</Label>
                                <Input
                                    type="text"
                                    name="ila"
                                    placeholder=""
                                />
                            </FormGroup>
                        </Col>
                        <Col  xl={2} lg={2} md={2}>
                            <FormGroup>
                                <Label for="iva">IVA</Label>
                                <Input
                                    type="text"
                                    name="iva"
                                    placeholder=""
                                />
                            </FormGroup>
                        </Col>
                        <Col  xl={2} lg={2} md={2}>
                            <FormGroup>
                                <Label for="total">Total</Label>
                                <Input
                                    type="text"
                                    name="total"
                                    placeholder=""
                                />
                            </FormGroup>
                        </Col>
                    
                    </Row>
                </Form>
            </CardBody>
        </Card>
        <br/>
        <Card>
            <CardBody>
            <Button color="secondary" size="sm"> <FaPencilAlt/> Aceptar</Button>
            </CardBody>
        </Card>

    </Page>
  );
};

export default FormPage;
